import { Fragment } from "react";

import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import ProjectsForm from "components/form/ProjectsForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Progetto creato con successo",
        errorMsg: "Errore nella creazione del progetto",
        navigateTo: { link: "/progetti" },
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function NuovoProgetto() {
    return (
        <Fragment>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Aggiungi Progetto</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <ProjectsForm />

                <ButtonSave />
            </SaveContextProvider>
        </Fragment>
    );
}

export default NuovoProgetto;
